import { Footer, Header as NavHeader } from '../components';
import { Container, Grid, Image } from 'semantic-ui-react';

export default function Layout({ children }) {
    return (
        <Container style={{ marginTop: '20px' }}>
            <Grid centered stackable columns={1}>
                <Grid.Column width={16} className='aligned'>
                    <Image src='/images/toilogo.png' fluid />
                    <NavHeader />
                    {children}
                </Grid.Column>
            </Grid>
            <Footer />
        </Container>
    )
}